module.exports = __webpack_public_path__ + "img/switzerland-colorectal-cancer-female.0d13ee12.png";